<template>
  <div
    v-if="isLoading"
    class="overlay"
  >
    <div class="overlay__inner">
      <div
        :style="loadingStyles"
        class="spinner spinner--stretch"
      >
        <div
          :style="rectStyles"
          class="rect rect-1"
        />
        <div
          :style="rectStyles"
          class="rect rect-2"
        />
        <div
          :style="rectStyles"
          class="rect rect-3"
        />
        <div
          :style="rectStyles"
          class="rect rect-4"
        />
        <div
          :style="rectStyles"
          class="rect rect-5"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    rectStyles () {
      return {
        'margin-right': '0.2rem',
        backgroundColor: '#000',
        animationDuration: '1.2s',
      };
    },
    loadingStyles () {
      return {
        width: '200px',
        height: '150px',
      };
    },
  },
};
</script>